export default __webpack_public_path__ + "static/media/Elevador.dd09a3c2.svg";